import {
  useStoryblokState,
  getStoryblokApi,
  StoryblokComponent,
} from "@storyblok/react";
import { sbBlok } from "../types/sb-types";
import BackgroundGraphic from "../components/BackgroundGraphic";
import styles from "../styles/Page.module.css";

export default function Page({ story, isTestEnv }: any) {
  story = useStoryblokState(story);

  return (
    <>
      {story.slug === "faq-rules" && (
        <div className={styles.bgGraphicsContainer}>
          <BackgroundGraphic align="right" />
          <BackgroundGraphic align="left" />
          <BackgroundGraphic align="right" />
        </div>
      )}
      {(story.slug === "schedule" ||
        story.slug === "prizes" ||
        story.slug === "prize-list" ||
        story.slug === "welcome-from-ceo" ||
        story.slug === "leaderboard" ||
        story.slug === "players-guide") && (
        <BackgroundGraphic
          align={story.slug === "players-guide" ? "left" : "right"}
        />
      )}
      {story?.content?.body?.map((c: sbBlok) => {
        if (
          c.component === "prize_pool_table" ||
          c.component === "prize_list"
        ) {
          return (
            <StoryblokComponent key={c._uid} blok={c} isTestEnv={isTestEnv} />
          );
        }
        return <StoryblokComponent key={c._uid} blok={c} />;
      })}
    </>
  );
}

export async function getStaticPaths() {
  const storyblokApi = getStoryblokApi();
  const { data } = await storyblokApi.get("cdn/links/", {
    version: process.env.VERCEL_ENV === "production" ? "published" : "draft",
  });

  let paths: any = [];
  Object.keys(data.links).forEach((linkKey) => {
    if (
      data.links[linkKey].is_folder ||
      data.links[linkKey].slug === "home" ||
      data.links[linkKey].slug === "join" ||
      data.links[linkKey].slug === "schedule" ||
      data.links[linkKey].slug === "leaderboard" ||
      data.links[linkKey].slug === "highlights" ||
      data.links[linkKey].slug.split("/")[0] === "news" ||
      data.links[linkKey].slug.split("/")[0] === "order-of-merit" ||
      data.links[linkKey].slug.split("/")[0] === "amateur"
    ) {
      return;
    }

    const slug = data.links[linkKey].slug;
    let splittedSlug = slug.split("/");

    paths.push({ params: { slug: splittedSlug } });
  });

  return {
    paths,
    fallback: false,
  };
}

export async function getStaticProps({ params }: any) {
  const slug = params.slug ? params.slug.join("/") : "home";

  const sbParams = {
    version: process.env.VERCEL_ENV === "production" ? "published" : "draft",
    resolve_links: "url",
  };

  const storyblokApi = getStoryblokApi();
  const { data } = await storyblokApi.get(`cdn/stories/${slug}`, sbParams);

  return {
    props: {
      story: data ? data.story : false,
      key: data ? data.story.id : false,
      isTestEnv: process.env.VERCEL_ENV !== "production",
    },
    revalidate: 10,
  };
}
